import { createContext } from "react";

export const ContractsContext = createContext(null);
